document.addEventListener('DOMContentLoaded', () => {
  const sliderEl = document.querySelector(
    '.slider-variation__social-slider.wp-block-bb-block-slider .swiper',
  );
  if (!sliderEl) return;

  let player = null;
  let playerObserver = null;

  /**
   * Sets an observer to ensure JW Player is found within the active slide.
   *
   * If the observer is already set, return early to avoid an observer loop.
   */
  const waitForActivePlayer = () => {
    if (playerObserver) return;
    playerObserver = new MutationObserver(() => {
      const activeSlideEl = sliderEl.querySelector('.swiper-slide-active');
      if (!activeSlideEl) return;
      const activePlayerEl = activeSlideEl.querySelector('.jwplayer');
      if (!activePlayerEl) return;
      playerObserver.disconnect();
      playerObserver = null;
      player = window.jwplayer(activePlayerEl);
      if (player) player.play();
    });
    playerObserver.observe(sliderEl, { childList: true, subtree: true });
  };

  /**
   * Initializes the swiper, plays the active slide’s video, on slideChangeTransitionEnd
   * pauses the previous player and plays the new active slide.
   */
  const initSwiper = () => {
    if (!sliderEl.classList.contains('swiper-initialized') || !sliderEl.swiper) return false;
    const swiper = sliderEl.swiper;

    const initialPlayerEl = sliderEl.querySelector('.swiper-slide-active .jwplayer');
    if (!initialPlayerEl) {
      waitForActivePlayer();
    } else {
      player = window.jwplayer(initialPlayerEl);
      if (player) player.play();
    }

    swiper.on('slideChangeTransitionEnd', () => {
      if (player) player.pause();

      const activeSlideEl = sliderEl.querySelector('.swiper-slide-active');
      if (!activeSlideEl) return;
      const activePlayerEl = activeSlideEl.querySelector('.jwplayer');
      if (!activePlayerEl) {
        waitForActivePlayer();
        return;
      }

      player = window.jwplayer(activePlayerEl);
      if (player) player.play();
    });

    return true;
  };

  if (initSwiper()) return;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (initSwiper()) {
          observer.disconnect();
          break;
        }
      }
    }
  });

  observer.observe(sliderEl, { attributes: true, attributeFilter: ['class'] });
});
